/**
 * Trouble Signing In Dropdown Component
 * Handles the issue selection dropdown on the password reset page
 */

window.TroubleSigninDropdown = window.TroubleSigninDropdown || {
  /**
   * Initialize the dropdown functionality
   */
  init: function() {
    const dropdown = document.querySelector('[data-dropdown]');
    if (!dropdown) return;

    const trigger = dropdown.querySelector('[data-dropdown-trigger]');
    const menu = dropdown.querySelector('[data-dropdown-menu]');
    const options = menu ? menu.querySelectorAll('[data-option]') : [];
    const dropdownValue = trigger.querySelector('.dropdown-value');

    if (!trigger || !menu) return;

    // Toggle dropdown
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const isOpen = menu.style.display === 'block';
      menu.style.display = isOpen ? 'none' : 'block';
      trigger.classList.toggle('active', !isOpen);
    });

    // Handle option selection
    options.forEach(option => {
      option.addEventListener('click', (e) => {
        e.preventDefault();
        const optionType = option.getAttribute('data-option');
        const optionTitle = option.textContent.trim();

        // Update dropdown value
        dropdownValue.textContent = optionTitle;

        // Add has-content class to trigger floating label
        trigger.classList.add('has-content');

        // Remove active class from all options
        options.forEach(opt => opt.classList.remove('active'));
        // Add active class to selected option
        option.classList.add('active');

        // Close dropdown
        menu.style.display = 'none';
        trigger.classList.remove('active');

        // Update Alpine state with error handling
        try {
          const alpineEl = dropdown.closest('[x-data]');
          if (alpineEl && typeof Alpine !== 'undefined') {
            const alpineComponent = Alpine.$data(alpineEl);
            if (alpineComponent) {
              alpineComponent.selectedIssue = optionType;
            }
          }
        } catch (error) {
          console.error('Error updating Alpine state:', error);
        }

        // Handle navigation based on selected option
        const config = window.TroubleSigninConfig;
        if (!config || !config.paths) {
          console.error('TroubleSigninConfig not found or missing paths');
          return;
        }

        const emailField = document.getElementById('user_email');
        const email = emailField ? emailField.value.trim() : '';
        let targetPath = null;

        // Determine target path based on option type
        if (optionType === 'reset-password') {
          targetPath = config.paths.password;
        } else if (optionType === 'confirmation-email') {
          targetPath = config.paths.confirmation;
        } else if (optionType === 'unlock-account') {
          targetPath = config.paths.unlock;
        }

        // Only navigate if we're not already on the target page
        if (targetPath) {
          const currentPath = window.location.pathname;

          // Check if we're already on the target page
          if (currentPath !== targetPath) {
            // TODO: Pass email?
            // const url = email ? `${targetPath}?email=${encodeURIComponent(email)}` : targetPath;
            const url = targetPath;
            window.location.href = url;
          }
          // If we're already on the correct page, just update the Alpine state (already done above)
        }
      });
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', (e) => {
      if (!dropdown.contains(e.target)) {
        menu.style.display = 'none';
        trigger.classList.remove('active');
      }
    });
  }
};

// Auto-initialize on DOMContentLoaded
document.addEventListener('DOMContentLoaded', function() {
  window.TroubleSigninDropdown.init();
});
